export default {
  buttons: {
    add: 'Toevoegen',
  },
  AddOn: {
    label: 'Add-on',
    title: 'Ontvang uw mobiele app',
    subscribed: 'Geabonneerd',
    cta: 'Ontvang uw mobiele app',
    price_per_month: '{{price}} / maand',
    tax_included: 'incl. toepasselijke belasting',
    apple_developer_note:
      'Vereist een Apple Developer-account ($99/jaar, betaald aan Apple) in de juridische entiteit van het restaurant.',
    features: {
      stores: 'Vermeld in de App Store en Google Play',
      push: 'Pushmeldingen naar uw gasten',
      loyalty: 'Loyaliteitspunten en beloningen',
      commission: 'Rechtstreeks bestellen met 0% commissie',
    },
  },
};
